import React, { useState } from 'react';
import cn from 'classnames';
import { uuid } from 'utils/dom';
import { BREAKPOINTS } from 'constants';
import ExtraFlyoutTabDrawer from 'components/ReservationFlow/Extras/ExtraFlyoutTabDrawer';
import FlyoutTab from './FlyoutTab';
import FlyoutTabDrawer from './FlyoutTabDrawer';
import { propTypes, defaultProps } from './FlyoutTabsPropTypes';

const maxItemsPerRow = 4;
const tabId = uuid();

const FlyoutTabs = ({
  breakpoint,
  className,
  contentKey,
  fullWidth,
  icon,
  labelKey,
  hasClearBelow,
  isExtrasDrawer,
  items = [],
}) => {
  const [expandedId, setExpandedId] = useState(null);

  const handleExpand = (id) => () => {
    setExpandedId((prevId) => (prevId !== id ? id : null));
  };

  const getParentItemsArray = () => {
    const parentItemsArray = [];

    for (let i = 0; i < items.length; i += maxItemsPerRow) {
      parentItemsArray.push(items.slice(i, i + maxItemsPerRow));
    }

    return parentItemsArray;
  };

  const isSmall = breakpoint === BREAKPOINTS.SMALL;
  const parentItemsArray = getParentItemsArray();
  const TabDrawer = isExtrasDrawer ? ExtraFlyoutTabDrawer : FlyoutTabDrawer;

  return parentItemsArray.map((itemsArray, itemsArray_index) => (
    <section
      key={itemsArray_index}
      className={cn('flyout-tabs', { 'full-width': fullWidth, 'half-width': !fullWidth }, className)}
    >
      <ul className='flyout-tabs__list'>
        {itemsArray.map((item, index) => {
          const itemId = `${tabId}_${itemsArray_index}_${index}`;

          return (
            <FlyoutTab
              icon={icon}
              item={item}
              isExpanded={itemId === expandedId}
              isSmall={isSmall}
              fullWidth={fullWidth}
              labelKey={labelKey}
              contentKey={contentKey}
              key={itemId}
              onClick={handleExpand(itemId)}
              uuid={itemId}
              isExtrasDrawer={isExtrasDrawer}
            />
          );
        })}
      </ul>
      {!isSmall && fullWidth && (
        <ul className='flyout-tabs__drawer-list'>
          {itemsArray.map((item, index) => {
            const itemId = `${tabId}_${itemsArray_index}_${index}`;

            return (
              <li key={itemId}>
                <TabDrawer
                  contentKey={contentKey}
                  item={item}
                  isExpanded={itemId === expandedId}
                  uuid={itemId}
                  hasClearBelow={hasClearBelow}
                />
              </li>
            );
          })}
        </ul>
      )}
    </section>
  ));
};

FlyoutTabs.propTypes = propTypes;
FlyoutTabs.defaultProps = defaultProps;

export default FlyoutTabs;
